var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"Notification"}},[_c('VSystemMessage',{attrs:{"primaryText":"Forgot your password?"}},[_c('div',{staticClass:"forgot-wrapper"},[_c('h3',[_vm._v("Enter your email address")]),_c('ForgotPasswordForm')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }